var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#D8DDE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2354 7.70183L14.6079 5.05882C14.5702 5.02091 14.5203 5.00009 14.4669 5.00009C14.4136 5.00009 14.364 5.02092 14.3263 5.05883L12.7696 6.62486L12.7678 6.63047L12.7367 6.65797L6.72429 12.7066C6.69642 12.7347 6.67758 12.7699 6.66988 12.8084L6.0043 16.1216C5.99103 16.1876 6.01147 16.2551 6.05872 16.3029C6.09641 16.3406 6.14631 16.3614 6.19966 16.3614C6.21293 16.3614 6.22593 16.3601 6.23814 16.3577L9.53227 15.6877C9.57102 15.6799 9.60579 15.661 9.6334 15.6332L17.2354 7.98513C17.2731 7.94748 17.2935 7.89701 17.2935 7.84334C17.2935 7.78968 17.2728 7.73948 17.2354 7.70183ZM9.39398 15.3072L6.45365 15.9054L7.04784 12.9472L7.91575 12.0741L10.2619 14.4343L9.39398 15.3072ZM10.5432 14.151L8.19709 11.791L12.8814 7.0785L15.2272 9.43849L10.543 14.151L10.5432 14.151ZM15.5091 9.15519L13.1632 6.7952L14.467 5.48363L16.8131 7.84362L15.5091 9.15519Z",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicEdit);
export default __webpack_public_path__ + "static/media/profile-pic-edit.af39290e732eb9941231e443a5d3e05b.svg";
export { ForwardRef as ReactComponent };